import { Grid2, useMediaQuery, useTheme } from '@mui/material'
import { memo } from 'react'

import PageTitle from 'src/components/shared/pageTitle/PageTitle'
import ClaimStaking from './ClaimStaking'
import FoundersKeys from './FoundersKeys'
import MembershipLevels from './MembershipLevels'
import StakingReward from './StakingReward'
import StakingFormContainer from '../../containers/staking/StakingFormContainer'

const Staking = ({
  t,
  connectedWallet,
  stakingProfile,
  mainProfile: { userTier, tiers },
  walletProfile,
  onClaimReward,
  onStakedClaim,
  onRefreshUserTier,
  symbol,
  stakingSymbolReward,
  walletConnectProps
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const stakingFormContent = () => (
    <Grid2 size={{ xs: 12 }}>
      <StakingFormContainer walletConnectProps={walletConnectProps} t={t} />
    </Grid2>
  )

  return (
    <>
      <PageTitle title={t('navigation.staking')} />
      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, md: 8 }}>
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12 }}>
              <ClaimStaking
                t={t}
                stakingProfile={stakingProfile}
                userTier={userTier}
                onStakedClaim={onStakedClaim}
                onRefreshUserTier={onRefreshUserTier}
              />
            </Grid2>

            {isMobile && stakingFormContent()}

            <Grid2 size={{ xs: 12 }}>
              <StakingReward
                t={t}
                stakingProfile={stakingProfile}
                tier={userTier.tier}
                onClaimReward={onClaimReward}
                symbol={symbol}
                stakingSymbolReward={stakingSymbolReward}
              />
            </Grid2>

            <Grid2 size={{ xs: 12 }}>
              <MembershipLevels t={t} tiers={tiers} userTier={userTier} />
            </Grid2>
          </Grid2>
        </Grid2>

        <Grid2 size={{ xs: 12, md: 4 }}>
          <Grid2 container spacing={3}>
            {!isMobile && stakingFormContent()}
            <Grid2 size={{ xs: 12 }}>
              <FoundersKeys
                t={t}
                stakingProfile={stakingProfile}
                connectedWallet={connectedWallet}
                walletProfile={walletProfile}
              />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  )
}

export default memo(Staking)
